import { render, staticRenderFns } from "./MentionEditor.vue?vue&type=template&id=3a4f009b&scoped=true"
import script from "./MentionEditor.vue?vue&type=script&lang=js"
export * from "./MentionEditor.vue?vue&type=script&lang=js"
import style0 from "./MentionEditor.vue?vue&type=style&index=0&id=3a4f009b&prod&lang=scss&scoped=true"
import style1 from "./MentionEditor.vue?vue&type=style&index=1&id=3a4f009b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4f009b",
  null
  
)

export default component.exports